import styled from 'styled-components';
import {GlobalColors, GlobalFonts} from '../../globals';

export const ContClientsSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 80px 0 180px 0;
  background:rgb(255, 255, 255);

  @media(min-width: 300px) and (max-width: 767px){
    padding: 60px 0;
  }
`;

export const TitleClients = styled.h2`
  font-family: ${GlobalFonts.fontBold};
  font-size: 48px;
  line-height: 56px;
  text-align: center;
  color: ${GlobalColors.colorPrimary};
  margin-bottom: 60px;
  padding: 0 0 80px 0;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 40px;
  }
`;

export const ClientsGrid = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 60px;
  width: 100%;

  @media(min-width: 300px) and (max-width: 767px){
    gap: 40px;
    width: 90%;
    & > * {
      flex: 0 0 calc(50% - 20px);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    & > :last-child:nth-child(2n+1) {
      flex-basis: 100%;
    }
  }
`;

export const ClientItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ClientLogo = styled.img`
  display: block;
  max-height: 60px; /* cap height to avoid very large logos */
  width: auto;
  object-fit: contain;
  filter: grayscale(100%) brightness(0);
  opacity: 0.95;
  transition: all 0.3s ease;

  ${ClientItem}:hover & {
    filter: none; /* show full color on hover */
    opacity: 1;
  }

  @media(min-width: 300px) and (max-width: 767px){
    max-height: 50px;
    width: 100%;
    max-width: 220px;
    margin: 0 auto;
  }
`;
